import { render, staticRenderFns } from "./RelationAbstract.vue?vue&type=template&id=2f88fe0a&scoped=true&"
import script from "./RelationAbstract.vue?vue&type=script&lang=js&"
export * from "./RelationAbstract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88fe0a",
  null
  
)

export default component.exports